export default "__VITE_ASSET__BPLDOLV5__"